import CustomerOutlet from "./customers/customer-outlet";
import Kyc from "./customers/pages/kyc";
import Customers from "./customers/pages/customers";
import { Profile } from "./customers/pages/profile";
import AdminUser from "./admins/admin-user";
import AdminUsers from "./admins/admin-users";
import Products from "./customers/pages/products";
import Transactions from "./customers/pages/transactions";
import Documents from "./customers/pages/documents";
import Accounts from "./customers/pages/accounts";
import Teams from "./customers/pages/teams";
import { ActivityLog } from "./customers/pages/activity-log";
import ManageAdminRoles from "./admins/manage-admin-roles";
import Referees from "./customers/pages/referees/referees";

const UserRoutes = [
  {
    path: "/users",
    children: [
      {
        path: "customers",
        element: <Customers />,
      },
      {
        path: "customers",
        element: <CustomerOutlet />,
        children: [
          {
            path: "profile/:userId",
            element: <Profile />,
          },
          {
            path: "kyc/:userId",
            element: <Kyc />,
          },
          {
            path: "teams/:userId",
            element: <Teams />,
          },
          {
            path: "products/:userId",
            element: <Products />,
          },
          {
            path: "transactions/:userId",
            element: <Transactions />,
          },
          {
            path: "referees/:userId",
            element: <Referees />,
          },
          {
            path: "documents/:userId",
            element: <Documents />,
          },
          {
            path: "accounts/:userId",
            element: <Accounts />,
          },
          {
            path: "activity/:userId",
            element: <ActivityLog />,
          },
        ],
      },
      {
        path: "admins",
        children: [
          {
            path: "",
            element: <AdminUsers />,
          },
          {
            path: "manage-roles",
            element: <ManageAdminRoles />,
          },
          {
            path: "profile/:userId",
            element: <AdminUser />,
          },
        ],
      },
    ],
  },
];

export default UserRoutes;
